var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import { Prop } from 'vue-property-decorator';
import Icon from './Icon';
import './IconBtn.style.scss';
let IconBtn = class IconBtn extends VueType {
    onClick() {
        this.$emit('click');
    }
    render() {
        return <span class="icon_btn pos" onClick={this.onClick}>
            <Icon w={14} h={14} xlink={`#${this.svgid}`}></Icon>
            {this.text || ''}
        </span>;
    }
};
__decorate([
    Prop({ default: '标题' })
], IconBtn.prototype, "text", void 0);
__decorate([
    Prop({ default: 'svg_clear_all' })
], IconBtn.prototype, "svgid", void 0);
IconBtn = __decorate([
    Component
], IconBtn);
export default IconBtn;
